import i18n from "i18next";
import { IBaseError } from "types";

const tryT = (key: string): string | null => {
    const fullKey = `messages.${key}`;
    const translated = i18n.t(fullKey);
    return translated !== fullKey ? translated : null;
};

export const getErrorMessagesV2 = (error: IBaseError): string[] => {
    const errorMessages: string[] = [];
    const defaultMessage = i18n.t("messages.unexpected_fail");

    if (!error) {
        return [defaultMessage];
    }

    if (error.errors && typeof error.errors === "object" && Object.keys(error.errors).length > 0) {
        Object.entries(error.errors).forEach(([fieldKey, value]) => {
            if (value == null) {
                return;
            }

            let foundTranslation = false;

            if (Array.isArray(value)) {
                value.forEach(item => {
                    if (item != null && item !== "") {
                        const translated = tryT(String(item));
                        if (translated) {
                            errorMessages.push(translated);
                            foundTranslation = true;
                        }
                    }
                });
            } else if (value !== "") {
                const translated = tryT(String(value));
                if (translated) {
                    errorMessages.push(translated);
                    foundTranslation = true;
                }
            }

            if (!foundTranslation) {
                const translatedKey = tryT(fieldKey);
                if (translatedKey) {
                    errorMessages.push(translatedKey);
                    foundTranslation = true;
                }
            }
        });
    }

    if (errorMessages.length === 0 && error.message) {
        const messageStr = String(error.message).trim();
        if (messageStr) {
            const translatedMessage = tryT(messageStr);
            if (translatedMessage) {
                errorMessages.push(translatedMessage);
            }
        }
    }

    if (errorMessages.length === 0) {
        errorMessages.push(defaultMessage);
    }

    return [...new Set(errorMessages)];
};
